function getPaginationCount(total: number, limit: number): number {
  return total && limit ? Math.ceil(total / limit) : 0
}

export { getPaginationCount }
